// extracted by mini-css-extract-plugin
export default {"overlayContainer":"styles_overlayContainer__1vS+c","overlayContent":"styles_overlayContent__FIGfy","fadeIn":"styles_fadeIn__aE6Mn"};